import React, { Component } from 'react';
import './footer.css';

function Footer() {
  return (
    <footer id="footer" className="footer">

      <div className="footer-inner">

        <div className="footer-brand">
          <h3>Leonardo da Vinci</h3>
          <p>
            An exploration of history's greatest polymath —
            painter, scientist, engineer, and eternal dreamer.
          </p>
        </div>

        <div className="footer-col">
          <h4>Sections</h4>
          <ul>
            <li><a href="#hero">Introduction</a></li>
            <li><a href="#overview">Overview</a></li>
            <li><a href="#collage">Collage</a></li>
            <li><a href="#timeline">Timeline</a></li>
            <li><a href="#quote">Quote</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Sources</h4>
          <ul>
            <li><a href="#">Codex Atlanticus</a></li>
            <li><a href="#">Royal Collection Trust</a></li>
            <li><a href="#">Museo Nazionale</a></li>
            <li><a href="#">Walter Isaacson</a></li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2025 — Historical Character Project</p>
        <p>Designed with <span className="footer-heart">♥</span> for the Renaissance</p>
      </div>


    </footer>
  );
}

export default Footer;